import { Component, OnInit } from '@angular/core';
import {FilterService} from '../../shared/filter.service';
declare const $: any;

@Component({
  selector: 'ciu-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  searchWord: string;

  constructor(private filterService: FilterService) { }

  ngOnInit() {
  }
 
  search() {
    this.filterService.search(this.searchWord);
    $( '.search__close__btn .search__close__btn_icon' ).click();
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/header/search/search.component.ts